<template>
  <v-card>
    <v-card-title>
      <h1 class="display-1">
        {{ title }}
      </h1>
    </v-card-title>
    <v-card-text>
      <va-list disable-export>
        <va-data-table disable-clone disable-select :fields="fields"></va-data-table>
      </va-list>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        fields: [
          {
            source: "email",
            sortable: true,
          },
          {
            source: "name",
            sortable: true,
          },
          {
            source: "timezone",
            sortable: true,
          },
        ],
      };
    },
  };
</script>
